import React from 'react';
import { Router, hashHistory } from 'react-router';
import {BottomNavigation, BottomNavigationItem} from 'material-ui/BottomNavigation';
import Paper from 'material-ui/Paper';

// icons
import ActionList from 'material-ui/svg-icons/action/list';
import ActionHome from 'material-ui/svg-icons/action/home';
import ActionQuestionAnswer from 'material-ui/svg-icons/action/question-answer';
import ContentAddBox from 'material-ui/svg-icons/content/add-box';

const listIcon = <ActionList />;
const homeIcon = <ActionHome />;
const activeQuizIcon = <ActionQuestionAnswer />;
const addQuiz = <ContentAddBox />;

const Navigation = React.createClass({
	_selectView: function(index, link) {
		this.props.selectView(index);
		hashHistory.push(link);
	},
	render: function() {
		const style = {
			position: 'fixed',
			bottom: '0',
			width: '100%'
		}
		return (
			<Paper zDepth={2} style={style}>
				<BottomNavigation selectedIndex={this.props.selectedIndex}>
					<BottomNavigationItem
						label="Dashboard"
						icon={homeIcon}
						onTouchTap={() => this._selectView(0, '/')}
					/>
					<BottomNavigationItem
						label="Create"
						icon={addQuiz}
						onTouchTap={() => this._selectView(1, '/create')}
					/>
					<BottomNavigationItem
						label="Quizzes"
						icon={listIcon}
						onTouchTap={() => this._selectView(2, '/list')}
					/>
					<BottomNavigationItem
						label="Active"
						icon={activeQuizIcon}
						onTouchTap={() => this._selectView(3, '/quizzes/' + this.props.activeQuiz)}
					/>
				</BottomNavigation>
			</Paper>
		)
	}
});

export default Navigation;


// WEBPACK FOOTER //
// ./src/components/navigation.jsx